// extracted by mini-css-extract-plugin
export default {"select":"ToggleInput_select__jkoFg","icon":"ToggleInput_icon__RQC7Z"};